import { questionContainer } from '../questionContainer/index'
import { QuestionComponentLookup } from './questionFormComponents'
const QuestionContainer = questionContainer(QuestionComponentLookup)
export { QuestionContainer }
